import youtubeModule from '../modules/youtube-module';
import YoutubeVideo from './video/youtube-video';

const removeYoutubeCookieOverlay = async () => {
  const { body } = window.document;
  const ytGroup = body.getAttribute('data-yt-group')?.split(',');
  const $youtubeVideos = Array.from(
    document.getElementsByClassName('js-youtube-video-overlay-cookie'),
  );

  if (ytGroup && ytGroup.length) {
    const activeGroups = window.OnetrustActiveGroups?.split(',');
    if (activeGroups) {
      const isYSCAccepted = activeGroups.some(
        (value: string) => ytGroup.includes(value),
      );

      if (isYSCAccepted) {
        $youtubeVideos.map((video) => video.classList.add('hidden'));
        const youtubePlayer = await youtubeModule();
        if (youtubePlayer instanceof YoutubeVideo) {
          youtubePlayer.init();
        }
      }
      if (!isYSCAccepted) {
        $youtubeVideos.map((video) => video.classList.remove('hidden'));
      }
    }
  }
};

export default class {
  constructor() {
    setTimeout(() => {
      // Prevent autoplay on YT videos
      const consentObject = document.cookie.split(';').reduce((cookies, cookie) => {
        const [name, value] = cookie.split('=').map((cookieName) => cookieName.trim());
        return { ...cookies, [name]: value };
      }, {});

      Object.entries(consentObject).forEach(([name]) => {
        if (name === 'OptanonAlertBoxClosed' && name.length) {
          removeYoutubeCookieOverlay();
        }
      });

      window.OneTrust?.OnConsentChanged(removeYoutubeCookieOverlay);
    }, 500);
  }
}
